// extracted by mini-css-extract-plugin
export default {"search-table":"modal_search-table__+XMZI","table-item":"modal_table-item__0yTp-","avatar":"modal_avatar__w8-kz"};